"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedDisabled = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
exports.SelectedDisabled = react_1.default.memo(function () { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ "data-testid": "selected-disabled-radio-icon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("rect", { x: "2.25", y: "2.25", width: "19.5", height: "19.5", rx: "9.75", fill: "#C5C8CB" }), (0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "12", r: "4.5", fill: "#A8ADB0" })] }))); });
